import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { CodaltComponent } from 'src/app/codalt.component';
import { Answer, Question, QuestionsService } from 'src/app/services/questions.service';

@Component({
    selector: 'app-quiz',
    templateUrl: './quiz.component.html',
    styleUrls: ['./quiz.component.scss'],
    standalone: false,
})
export class QuizComponent extends CodaltComponent implements OnInit {
    questions: Question[] = [];
    current = 0;
    quizFinished = false;
    answers: Answer[] = [];
    showClose = false;

    countdownValue = 30;
    constructor(
        private questionService: QuestionsService,
        public dialogRef: MatDialogRef<QuizComponent>,
        @Inject(MAT_DIALOG_DATA) public data: { id: number }
    ) {
        super();
    }

    ngOnInit(): void {
        this.subscriptions.add(
            this.questionService.getToolboxQuizAnswersByUser(this.data.id).subscribe({
                next: answers => {
                    const expectedIds = [...new Set(answers.map(a => String(a.question_id)))];

                    const groupedSets = [];
                    let currentSet = {};

                    for (const answer of answers) {
                        const qid = String(answer.question_id);
                        currentSet[qid] = answer;

                        if (Object.keys(currentSet).length === expectedIds.length) {
                            groupedSets.push(currentSet);
                            currentSet = {};
                        }
                    }

                    const hasFullyCorrectSet = groupedSets.some(set =>
                        expectedIds.every(qid => set[qid].is_correct === 1)
                    );

                    const correctSetIndexes = groupedSets
                        .map((set, index) => ({
                            index,
                            isCorrect: expectedIds.every(qid => set[qid].is_correct === 1),
                        }))
                        .filter(result => result.isCorrect)
                        .map(result => result.index);

                    this.answers = correctSetIndexes.flatMap(index => Object.values(groupedSets[index]));

                    this.quizFinished = hasFullyCorrectSet;
                },
            })
        );

        this.subscriptions.add(
            this.questionService.getQuestions(this.data.id).subscribe({
                next: questions => {
                    this.questions = questions;
                    this.current = 0;
                },
            })
        );
    }

    onAnswerSaved(answer) {
        this.answers.push(answer);
        if (this.current < this.questions.length - 1) {
            this.current++;
        } else {
            this.quizFinished = true;
        }
    }

    onShowClosed(show: boolean) {
        this.showClose = show;
    }

    close(): void {
        this.dialogRef.close();
    }

    setCountdownValue(value: number) {
        this.countdownValue = value;
    }
}
